import NewsletterTwentyContainer from "./containers/NewsletterTwentyContainer";
export default NewsletterTwentyContainer;
